import { images } from "@/data/resort";
import { useBooking } from "../booking-context";
import { ResortButton } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function AccommodationsIntro() {
  const { openBooking } = useBooking();

  return (
    <section
      id="overview"
      aria-labelledby="accommodations-intro-heading"
      className="bg-background pb-16 pt-24 md:pb-20 md:pt-26"
    >
      <div className="shell">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Room to Settle In</Eyebrow>
            </Reveal>
            <h2 id="accommodations-intro-heading" className="display-lg mt-6 max-w-[18ch]">
              <MaskReveal>Space for Weekend Stops,</MaskReveal>
              <MaskReveal delay={0.08}>Long Stays &amp;</MaskReveal>
              <MaskReveal delay={0.16}>Big Adventures</MaskReveal>
            </h2>

            <Reveal delay={0.12}>
              <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground md:text-[1.05rem]">
                <p>
                  Auburn RV Resort has a total of{" "}
                  <span className="text-foreground">71 RV sites of varying sizes</span>, including{" "}
                  <span className="text-foreground">10 pull-through sites</span>. Most sites are
                  approximately 25 feet wide, with lengths ranging from approximately 36 feet to 120
                  feet.
                </p>
                <p>
                  Many lots range from approximately 44 feet to 120 feet and can accommodate larger
                  RVs. Every RV site at this Auburn California RV resort includes sewer, water, 20 /
                  30 / 50 amp electrical service and complimentary WiFi.
                </p>
                <p>
                  Electricity is metered for guests staying{" "}
                  <span className="text-foreground">60 days or longer</span>.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.18}>
              <aside className="mt-10 border-l-2 border-accent bg-secondary/40 px-6 py-6 md:px-8">
                <p className="eyebrow text-foreground">Traveling with a larger rig?</p>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground md:text-base">
                  With sites reaching up to 120 feet in length, Auburn RV Resort offers options for
                  many larger motorhomes, fifth wheels and travel trailers. Contact the resort to
                  confirm the best site for your rig.
                </p>
              </aside>
            </Reveal>

            <Reveal delay={0.22}>
              <ResortButton
                variant="solid"
                onClick={openBooking}
                className="mt-10 w-full sm:w-auto"
              >
                Check Site Availability
              </ResortButton>
            </Reveal>
          </div>

          <Reveal className="relative lg:col-span-6" y={40}>
            <img
              src={images.campgroundAerial}
              alt="Long pull-through RV site with full hookups at Auburn RV Resort"
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
